import logo from './logo.svg';
import './App.css';
import React, {useEffect, useRef, useState} from "react";
import {fetchStockFundamentals} from "./api";
import FundaTeaser from "./components/fundamentals/stockFundamentalTeaser";
import BondPriceSensitivity from "./components/bonds/bondPriceSensitivity";
import BondAnalyzer from "./components/bonds/bondAnalyzer";
import CouponReinvestmentVisualizer from "./components/bonds/couponReinvestmentVisualizer";
import VisualizerSwitcher from "./components/bonds/visualizerSwitcher";
import BondLadderVisualizer from "./components/bonds/bondLadderVisualizer";
import VaRVisualizer from "./components/quant/varVisualizer";
import VaRVisualizerDetailed from "./components/quant/varVisualizerDetailed";
import BinomialTree from "./components/options/binomialPricing";
import MonteCarloOptionSimulator from "./components/options/monteCarlo";
import UPIPayment from "./components/payment/upipayment";
import PlanSelectionPage from "./components/payment/plan_select";
// ✅ Metric Card Component
const MetricCard = ({ title, value, change }) => (
  <div style={styles.metricCard(change)}>
    <h3 style={{ fontSize: "18px", fontWeight: "600", color: "white"}}>{title}</h3>
    <p style={{ fontSize: "24px", fontWeight: "700" ,color: "white"}}>{value}</p>
    <small style={{ color: "white" }}>
      {change !== null ? `${change > 0 ? `+${change}%` : `${change}%`} ` : "N/A"}
    </small>
  </div>
);

// Main Component to Fetch and Display Data
const FundamentalRatios = () => {
  const [metrics, setMetrics] = useState({});
  const [latestDate, setLatestDate] = useState(null);
  const url = "http://localhost:8000/api/stockdata/fd/TATAMOTORS/liabilities"
 useEffect(() => {
    // fetch(url)  // Adjust API URL as needed
    //   .then(response => response.json())
     fetchStockFundamentals('BRITANNIA','all')
      .then(data => {
        if (!data || !data.Metric) {
          console.error("Invalid response format");
          return;
        }

        const metricEntries = Object.entries(data.Metric);
        if (metricEntries.length === 0) {
          console.error("No metric data available");
          return;
        }

        // Extract the latest available date dynamically
        const availableDates = Object.values(data.Metric)
          .map(item => Object.keys(item).filter(key => key !== "change"))
          .flat();

        const latest = availableDates.length ? availableDates[0] : null;
        setLatestDate(latest);

        setMetrics(data.Metric);
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);
    console.log("Data",metrics)
  return (
    <div style={styles.container}>
      {latestDate ? (
        Object.entries(metrics).map(([metricName, metricData]) => (
          <MetricCard
            key={metricName}
            title={metricName}
            value={metricData[latestDate] || "N/A"}
            change={metricData.change !== null ? metricData.change : "N/A"}
          />
        ))
      ) : (
        <p>No available fundamental data.</p>
      )}
    </div>
  );
};

// ✅ CSS as JavaScript Object (but separate from JSX)
const styles = {
  metricCard: (change) => ({
    padding: "10px",
    border: "1px solid",
    borderRadius: "8px",
    width: "150px",
    textAlign: "center",
    backgroundColor: change > 0 ? "#23d777" : change < 0 ? "#e86767" : "#35acef",
    borderColor: change > 0 ? "#23d777" : change < 0 ? "#e86767" : "#35acef",
    boxShadow: "2px 4px 8px rgba(0, 0, 0, 0.5)", // ✅ Adds a slight shadow below
  }),
  container: {
    display: "flex",
    flexWrap: "wrap", // ✅ Allows wrapping if too many cards
    gap: "16px",
    padding: "16px",
    justifyContent: "center",
  },
};

// export default FundamentalRatios;


function Test() {
  return (
    <div className="App">
      {/*<h1>Stock Price Analysis</h1>*/}
      {/*<DynamicStockCharts stocks={['TATASTEEL','TATAMOTORS','SBIN']}/>*/}
      {/*<Stockchart symbol="NIFTY FMCG" candles={false} smaFlag={false} metric={['return']} />*/}
      {/*<Stockchart symbol="IOC" levelFlag={true} volume={true}/>*/}
      {/*<Datatable table="ta" symbol="nifty_50"/>*/}
      {/*<OptionPricing/>*/}
      {/*  <HeaderCarousel/>*/}
      {/*  <CheckoutButton paymentAmount={5.25} order_no={"test_order"}/>*/}
        {/*<Bonds/>*/}
      {/*<Register/>*/}
      {/*<SocialLogin/>*/}
      {/*<Stockchart symbol="SBIN" levelFlag={true} volume={true}/>*/}
      {/*<OiTree symbol="SBIN"/>*/}
      {/*<StockChartest />*/}
      <div className="min-h-screen bg-gray-100 p-6">
        <header className="text-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Orion Analytics</h1>
          <p className="text-gray-600">Your Gateway to Market Insights</p>
        </header>
      <main className="space-y-6">
          <PlanSelectionPage/>
      </main>
    </div>
    </div>

  );
}

export default Test;
